export const healthProductBenefitEndpoints = (builder) => ({
  getHealthBenefits: builder.query({
    query: ({ insurerId, productId }) => ({
      url: `/HealthProductBenefit`,
      method: 'GET',
      params: { insurerId, productId },
    }),
    transformResponse: (response) => response.data || [],
    providesTags: ['HealthProductBenefit'],
  }),

  saveHealthProductBenefitMapping: builder.mutation({
    query: (payload) => ({
      url: `/HealthProductBenefit/mapping`,
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['HealthProductBenefit'],
  }),
  
  getHealthComparison: builder.query({
    query: (productIds) => ({
      url: `/HealthProductBenefit/comparison`,
      method: 'POST',
      body: { productIds },
    }),
    providesTags: ['HealthProductBenefit'],
  }),
});
